import { AuthService } from 'app/_services/auth.service';
import * as angular from 'angular';
import * as moment from 'pkp-moment-timezone-all-years';
import { Growl } from 'angular/custom/services/growl.service';
import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import { ConfirmModal } from 'app/_services/confirm-modal.factory';

class OperatorSettingsHolidaysCtrl implements ng.IController {
    newHoliday: Date | string;
    public settings: TsoSecondarySettingsDto;
    public standalone: boolean;
    public section: string;
    public holidays: string[];
    public holidayIds: number[];
    private today: Date;
    public minDate: Date;
    public validateMessage: string;
    private showPastDates: boolean;
    private unixNow: number;
    private holidayCalendarEnabled: boolean = false;
    private authenticatedUser: LoginResult;

    constructor(
        private TransmissionSystemOperator: TransmissionSystemOperatorResource,
        private authService: AuthService,
        public DATES,
        private growl: Growl,
        private errorHandler: ErrorHandler,
        private confirmModal: ConfirmModal
    ) {
        this.unixNow = Date.now();
        this.showPastDates = false;
    }

    $onInit(): void {
        this.today = new Date();
        this.minDate = new Date();
        this.minDate.setDate(this.today.getDate() + 1);

        this.authService.userLoginPromise.promise.then(
            (loginResult: LoginResult) => {
                this.authenticatedUser = loginResult;
                this.getHolidays();
            }
        );
    }

    public keyDown(e: KeyboardEvent): void {
        if (!(e.ctrlKey && e.keyCode === 13 && this.newHoliday)) {
            return;
        }

        if (this.validateIsFutureDate()) {
            this.addNewHoliday();
            this.validateMessage = '';
        } else {
            this.validateMessage = 'Please provide a valid date in the future.';
        }
    }

    public getHolidays() {
        this.TransmissionSystemOperator.queryHolidays(
            { id: this.authenticatedUser.referenceId },
            (res: string[]) => {
                this.holidays = res;
                if (this.holidays.length > 0) {
                    this.holidayCalendarEnabled = true;
                    this.holidayIds = this.holidays.map((a: any) => a.id);
                }
            },
            this.errorHandler
        );
    }

    public addNewHoliday(): void {
        if (!(this.newHoliday && this.validateIsFutureDate())) {
            this.validateMessage = 'Please provide a valid date in the future.';
            return;
        }

        this.validateMessage = '';
        this.TransmissionSystemOperator.createHoliday(
            { id: this.authenticatedUser.referenceId },
            moment(this.newHoliday).format('DD.MM.YYYY'),
            () => {
                this.growl.show('Successfully saved.', 'success');
                delete this.newHoliday;
                this.getHolidays();
            },
            this.errorHandler
        );
    }

    public deleteHoliday(id): void {
        this.TransmissionSystemOperator.deleteHolidays(
            { id: this.authenticatedUser.referenceId },
            [id],
            () => {
                this.growl.show('Successfully deleted.', 'success');
                this.getHolidays();
            },
            this.errorHandler
        );
    }

    public validateIsFutureDate() {
        return moment(this.today).diff(this.newHoliday) < 0;
        1;
    }

    public toggleHolidayCalendarEnabled() {
        this.holidayCalendarEnabled = !this.holidayCalendarEnabled;
        const text = `All holidays will be deleted.`;
        this.confirmModal(text).result.then(() => {
            this.holidays = [];
            delete this.newHoliday;
            this.validateMessage = '';
            return this.TransmissionSystemOperator.deleteHolidays(
                { id: this.authenticatedUser.referenceId },
                this.holidayIds,
                () =>
                    (this.holidayCalendarEnabled =
                        !this.holidayCalendarEnabled),
                this.errorHandler
            ).$promise;
        });
    }

    public filterPastDates(
        negate: boolean = false
    ): ng.IFilterFilterPredicateFunc<TsoFcfsHolidayDto> {
        return (
            value: TsoFcfsHolidayDto,
            index: number,
            array: TsoFcfsHolidayDto[]
        ): boolean => {
            const result: boolean =
                new Date(value.holiday as string).getTime() >= this.unixNow;
            return negate ? !result : result;
        };
    }
}

angular.module('app').component('pkpOperatorSettingsHolidays', {
    controller: OperatorSettingsHolidaysCtrl,
    template:
        require('app/operator-settings-secondary-market/operator-settings-holidays.component.html'),
    bindings: {
        settings: '=',
        standalone: '<',
        enabled: '=',
        section: '<'
    }
});
